import getSelectedTableView from './getSelectedTableView';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import TableView from '../store/schema/TableView';

const isItemView = (tableView?: TableView): boolean => {
    const selectedTableView = tableView || getSelectedTableView();
    return (
        !!selectedTableView &&
        !!selectedTableView.tableQuery &&
        selectedTableView.tableQuery.listViewType === ReactListViewType.Message
    );
};

export default isItemView;
